import { ElementsUsage, ElementsStats, ElementsUpload } from './ElementsUsage';
import { Devices } from './Devices';
import { Licences } from './Licences';
import { NewsPanel } from './News';

export default {
  ElementsUsage,
  ElementsUpload,
  Devices,
  Licences,
  NewsPanel,
};
